import React from "react";

export function Msg({ name, pic }) {
  return (
    <div>
      <img height="300" src={pic} alt={name} />
      <h1 className="name">Hi, {name}😊!!!</h1>
    </div>
  );
}
